import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ResourceResDto } from '../_dtos/resourceResDto';

export interface PaginationParams {
  startIndex?: number;
  pageSize: number;
}

export interface FilterParams {
  searchText?: string;
  typeFilter?: string;
  statusFilter?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {
  private readonly apiUrl = `${environment.backendBaseUrl}/resources`;

  constructor(private http: HttpClient) {}

  getMyResources(pagination?: PaginationParams): Observable<ResourceResDto> {
    const url = `${this.apiUrl}/me`;
    let params = new HttpParams();

    if (pagination?.startIndex)
      params = params.set('startIndex', pagination.startIndex);

    if (pagination?.pageSize)
      params = params.set('pageSize', pagination.pageSize.toString());

    return this.http.get<ResourceResDto>(url, { params });
  }

  filterMyResources(
    filters: FilterParams,
    pagination: PaginationParams,
  ): Observable<ResourceResDto> {
    const url = `${this.apiUrl}/me`;
    let params = new HttpParams();

    // Add filter parameters
    if (filters.searchText)
      params = params.set('searchText', filters.searchText);

    if (filters.typeFilter)
      params = params.set('typeFilter', filters.typeFilter);

    if (filters.statusFilter)
      params = params.set('statusFilter', filters.statusFilter);

    // Add pagination parameters
    if (pagination.startIndex)
      params = params.set('startIndex', pagination.startIndex);

    if (pagination.pageSize)
      params = params.set('pageSize', pagination.pageSize.toString());

    return this.http.get<ResourceResDto>(url, { params });
  }

  getAllResources(
    filters: FilterParams,
    pagination: PaginationParams,
  ): Observable<ResourceResDto> {
    const url = `${this.apiUrl}`;
    let params = new HttpParams();

    // Add filter parameters
    if (filters.searchText)
      params = params.set('searchText', filters.searchText);

    // Add pagination parameters
    if (pagination.startIndex)
      params = params.set('startIndex', pagination.startIndex);

    if (pagination.pageSize)
      params = params.set('pageSize', pagination.pageSize.toString());

    return this.http.get<ResourceResDto>(url, { params });
  }
}
